export default function Credit() {
  return <div style={{ padding: 24 }}><h2>Credit - Coming Soon</h2></div>;
}
